import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-textile-model-category6s',
  templateUrl: './textile-model-category6s.component.html',
  styleUrls: ['./textile-model-category6s.component.css']
})
export class TextileModelCategory6sComponent implements OnInit {
    itemsListCategories6: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadTextileModelCategory6s() {
        this.itemsListCategories6 = await this.datatask.Post(2691);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'textilemodelcategory6':
                this.stateService?.go('textilemodelcategory6', { textilemodelcategory6_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadTextileModelCategory6s();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory6s', {
//        templateUrl: 'views/components/views/textileModelCategory6s/textileModelCategory6s.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'textileModelCategory6sService', function (stateService, textileModelCategory6sService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListCategories6: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory6s() {
//                vm.model.itemsListCategories6 = await textileModelCategory6sService.listTextileModelCategory6s();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'textilemodelcategory6':
//                        go({ textilemodelcategory6_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory6s();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
